// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"e6b84daa","68":"7008e8ac","163":"08a42076","239":"4302f2cf","275":"7753d364","288":"ce683711","353":"464feb06","465":"b0ebef42","623":"0f3f7442","707":"53217c19","780":"293802cf"}[chunkId] + ".chunk.js";
};